import Vue from 'vue'
import Wysiwyg from 'vue-wysiwyg'
import '../../node_modules/vue-wysiwyg/dist/vueWysiwyg.css'

Vue.use(Wysiwyg, {
    hideModules: { "image": true },
});
